<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputRadioList" });
import "tailwindcss/tailwind.css";
import { InputRadio } from "../index.js";
export let key;
export let name = "";
export let options = [];
export let label = void 0;
export let isDisabled = false;
export let isRequired = false;
export let css = "";
export let align = "vertical";
export let whitelist = [];
const filterWhitelist = (options2, whitelist2) => {
    if (whitelist2.length === 0) {
        return options2;
    }
    return options2.filter((option) => whitelist2.includes(option.key));
};
$: classes = `s8-form-row s8-${align}`;
</script>

<fieldset class = { classes }>

    {#if Array.isArray(options)}

        {#if label !== undefined}
            <legend>
                { label }
                {#if isRequired}
                    <span class = 's8-required-asterisk'>*</span>
                {/if}
            </legend>
        {/if}

        <ul class = { `s8-radio-list ${ css }` }>
            {#each filterWhitelist(options, whitelist) as option}
                <li>
                    <InputRadio
                        bind:key
                        { name }
                        value = { option.key }
                        label = { option.label }
                        isDisabled = { isDisabled || option.isDisabled }
                        isRequired = { isRequired || option.isRequired }
                        isIndeterminate = { option.isIndeterminate }
                    />
                </li>
            {/each}
        </ul>

    {/if}

</fieldset>

<style>

    fieldset.s8-form-row {
        position: relative;
        padding-top: 8px;
        padding-bottom: 8px;
    }

        fieldset.s8-form-row.s8-horizontal {
            align-items: center;
            display: flex;
        }

        fieldset.s8-form-row.s8-horizontal ul.s8-radio-list {
                display: flex;
            }

        fieldset.s8-form-row legend {
            float: left;
            margin-right: 10px;
        }

        fieldset.s8-form-row legend + * {
                clear: both;
            }

        fieldset.s8-form-row legend span.s8-required-asterisk {
                color: #8b0000;
                font-weight: bold;
                margin-left: 2px;
            }</style>